import {
  Box,
  CircularProgress,
  Button,
  Grid,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Badge,
  IconButton,
  useMediaQuery
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  TextBold,
  TextMedium,
  TextRegular,
  TextSemiBold
} from '../../../commonComponents/TextStyling'
import { useTheme } from '@mui/material/styles'
import moment from 'moment'
import AppButton from '../../../commonComponents/AppButton'
import serverData from '../../../api/ServerData'
import { logoutUser } from '../../../actions/loginActions'
import { useDispatch } from 'react-redux'
import NoRecordFound from '../../../commonComponents/NoRecordFound'
import callServer from '../../../api/callServer'
import { formatNumber, isEmpty, showToast } from '../../../utils/AppHelper'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import CustomModal from '../../../commonComponents/CustomModal'
import { currencySymbol } from '../../../utils/AppConstants'
import EditIcon from '@mui/icons-material/Edit'
import { MAX_CALENDAR_HEIGHT } from '@mui/x-date-pickers/internals/constants/dimensions'
import FeedbackModal from './FeedbackModal'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3
}

export default function TakeAction () {
  const theme = useTheme()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const data = location.state || {}
  const [applications, setApplications] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingBtn, setLoadingBtn] = useState(false)

  const [openModal, setOpenModal] = useState({ open: false })
  const [modal, setModal] = useState({
    open: false
  })

  const [openFeedbackModalodal, setOpenFeedbackModal] = useState({
    open: false
  })

  const [feedbackSentStatus, setFeedbackSentStatus] = useState(
    () => JSON.parse(localStorage.getItem('feedbackSentStatus')) || {}
  )

  const [isFeedbackSent, setIsFeedbackSent] = useState(false)

  const [progress, setProgress] = useState(0)
  const [progressCover, setProgressCover] = useState(0)
  const [leftOutDateModal, setLeftOutDateModal] = useState({ open: false })

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  useEffect(() => {
    localStorage.setItem(
      'feedbackSentStatus',
      JSON.stringify(feedbackSentStatus)
    )
  }, [feedbackSentStatus])

  useEffect(function () {
    getApplication()
  }, [])

  const getApplication = () => {
    setLoading(true)
    serverData.getApplicationsForReview(
      data,
      result => {
        if (result.status) {
          if (result.response.length > 0) {
            setApplications(result.response)
          } else {
            navigate('/employer/dashboard')
          }
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }
  const updateHiredApplicationStatus = body => {
    setLoadingBtn(true)

    serverData.updateHiredApplicationStatus(
      body,
      result => {
        if (result.status) {
          showToast(result.message, false)
          getApplication()
        } else {
          showToast(result.message)
        }
        setLoadingBtn(false)
      },
      error => {
        setLoadingBtn(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  const getListData = item => {
    var listData = [
      {
        label: 'Job position',
        value: item?.jobTitle
      },

      {
        label: 'Recruiter',
        value: item?.recruiterName
      },
      {
        label: 'Applied on',
        value: moment(item?.createdAt).format('D MMMM YYYY, dddd')
      }
    ]

    if (item.status === 'rejected' || item.status === 'hired') {
      listData.push({
        label: 'Status',
        value: `${item.status.toUpperCase()} ${
          isEmpty(item.isJoined)
            ? ''
            : item.isJoined
            ? '(Joined)'
            : '(Not joined)'
        }`
      })
    }
    if (item.managerReviewDate) {
      listData.push({
        label: 'Manager review date',
        value: moment(item.managerReviewDate).format('D MMMM YYYY, dddd')
      })
    }

    if (item.interviewStageDate) {
      listData.push({
        label: 'Interview date',
        value: moment(item.interviewStageDate).format('D MMMM YYYY, dddd')
      })
    }

    if (item.offerStageDate) {
      listData.push({
        label: 'Offer date',
        value: moment(item.offerStageDate).format('D MMMM YYYY, dddd')
      })
    }

    if (item.hiredOnDate) {
      listData.push({
        label: 'Hired on',
        value: moment(item.hiredOnDate).format('D MMMM YYYY, dddd')
      })
    }

    if (item.baseSalary) {
      listData.push({
        label: 'Base salary',
        value: `${currencySymbol} ${formatNumber(item.baseSalary)}`
      })
    }

    if (item.rejectedOnDate) {
      listData.push({
        label: 'Rejected on',
        value: moment(item.rejectedOnDate).format('D MMMM YYYY, dddd')
      })
    }
    if (item.joiningDate) {
      listData.push({
        label: 'Joining date',
        value: moment(item?.joiningDate).format('D MMMM YYYY, dddd'),
        component:
          item.isJoined !== true ? (
            <Grid item xs={1}>
              <IconButton
                onClick={() => {
                  setOpenModal({
                    open: true,
                    item: item,
                    status: data.status,
                    subStatus: item.subStatus,
                    updateApplication: getApplication,
                    isEdit: true,
                    onClose: () => {
                      setOpenModal({
                        open: false
                      })
                    }
                  })
                }}
                style={{
                  color: theme.palette.primary.main
                }}
              >
                <EditIcon />
              </IconButton>
            </Grid>
          ) : null
      })
    }

    if (item.leftOutDate) {
      listData.push({
        label: 'Left out on',
        value: moment(item?.leftOutDate).format('D MMMM YYYY, dddd')
      })
    }

    if (item.status === 'hired' && item.isJoined && item.leftOutDate === null) {
      listData.push({
        label: 'Payment amount (Status)',
        value: `${currencySymbol} ${formatNumber(
          item.commissionFromEmployer
        )} (${item.employerPaymentDone ? 'PAID' : 'UNPAID'})`,
        color: item.employerPaymentDone
          ? theme.palette.text.success
          : theme.palette.text.error
      })
      if (!item.employerPaymentDone) {
        listData.push({
          label: 'Due on',
          value: moment(item.guaranteePeriodEndDate).format('D MMMM YYYY, dddd')
        })
      }
    }

    return listData.map((row, index) => (
      <Grid
        container
        style={{
          backgroundColor:
            index % 2 !== 0
              ? theme.palette.background.paper
              : theme.palette.background.default,
          padding: '8px 16px'
        }}
      >
        <Grid item xs={4}>
          <TextBold style={{ fontSize: isMobile? '13px':'16px' }}>{row.label} :</TextBold>
        </Grid>
        <Grid
          item
          xs={row.component ? 7 : 8}
          style={{
            textAlign: 'end',
            padding: row.component && '8px 8px 0px 0px'
          }}
        >
          <TextRegular
            style={{
              fontSize: isMobile? '14px':'16px',
              color: row.color
            }}
          >
            {row.value}
          </TextRegular>
        </Grid>
        {row.component}
      </Grid>
    ))
  }

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <TextBold style={{ fontSize: '24px' }}>Applications</TextBold>
        <Badge
          badgeContent={applications.length}
          color='primary'
          style={{ left: 14, top: -8 }}
        />
      </Grid>
      {loading ? (
        <Grid
          container
          spacing={2}
          direction={'column'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            width: '100%'
          }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : applications.length > 0 ? (
        applications.map((item, index) => (
          <Grid
            container
            style={{
              padding: '24px',
              background: theme.palette.background.paper,
              borderRadius: '16px',
              border: `1px solid ${theme.palette.border.main}`,
              marginTop: '24px'
            }}
          >
            <Grid item md={6} xs={12} >
              <Grid item xs={12}>
                <TextBold style={{ fontSize: '18px' }}>
                  {item?.candidateFirstName} {item?.candidateLastName}
                </TextBold>
              </Grid>
              <Grid item xs={12}>
                <TextRegular
                  style={{
                    fontSize: '16px',
                    color: theme.palette.text.secondary
                  }}
                >
                  {item?.candidateEmail}
                </TextRegular>
              </Grid>
              <Grid item xs={12}>
                <TextRegular
                  style={{
                    fontSize: '16px',
                    color: theme.palette.text.secondary
                  }}
                >
                  {item?.candidatePhone}
                </TextRegular>
              </Grid>
              <Grid item xs={12} style={{ display: 'flex' }}>
                <Grid
                  item
                  style={{ marginBottom: '32px', marginRight: '24px' }}
                >
                  <AppButton
                    name={
                      progress > 0
                        ? `Downloading: ${progress}%`
                        : 'Download resume'
                    }
                    fullWidth={false}
                    onClick={() => {
                      let file = item.resumePath
                      let fileName = `${item?.candidateFirstName}${
                        item?.candidateLastName
                      }Resume.${file.split('.').pop()}`
                      callServer.downloadFile(
                        file,
                        fileName,
                        percentCompleted => {
                          setProgress(
                            percentCompleted === 100 ? 0 : percentCompleted
                          )
                        }
                      )
                    }}
                    style={{
                      width: 'fit-content',
                      fontSize: '16px',
                      padding: '12px 27px',
                      borderRadius: '8px',
                      marginTop: '24px'
                    }}
                  />
                </Grid>
                <Grid item style={{ marginBottom: '32px' }}>
                  {item?.coverLetterPath && (
                    <AppButton
                      name={
                        progressCover > 0
                          ? `Downloading: ${progressCover}%`
                          : 'Download cover letter'
                      }
                      fullWidth={false}
                      onClick={() => {
                        let file = item.coverLetterPath
                        let fileName = `${item?.candidateFirstName}${
                          item?.candidateLastName
                        }Cover.${file.split('.').pop()}`
                        callServer.downloadFile(
                          file,
                          fileName,
                          percentCompleted => {
                            setProgressCover(
                              percentCompleted === 100 ? 0 : percentCompleted
                            )
                          }
                        )
                      }}
                      style={{
                        width: 'fit-content',
                        fontSize: '16px',
                        padding: '12px 27px',
                        borderRadius: '8px',
                        marginTop: '24px'
                      }}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {item?.coverSummary !== null && (
                  <>
                    <TextBold style={{ fontSize: '18px' }}>
                      Cover Summary
                    </TextBold>
                    <Box
                      dangerouslySetInnerHTML={{
                        __html: item?.coverSummary
                      }}
                    />
                  </>
                )}
              </Grid>

              <Grid container spacing={2}>
                {item.status != '' && item.isFeedback === 1 && (
                  <Grid item>
                    <AppButton
                      loading={loadingBtn}
                      variant='outlined'
                      onClick={() => {
                        setOpenFeedbackModal({
                          open: true,
                          isSendFeedback: false,
                          applicationId: item.applicationId,
                          memberId: item?.memberId,
                          onClose: () => {
                            setOpenFeedbackModal({ open: false })
                          }
                        })
                      }}
                      name={'Show Feedback'}
                      style={{
                        width: 'fit-content',
                        fontSize: '16px',
                        padding: '12px 27px',
                        borderRadius: '8px',
                        marginTop: '24px'
                      }}
                    />
                  </Grid>
                )}
                {item.status === 'hired' && item.isJoined && (
                  <Grid item>
                    <AppButton
                      loading={loadingBtn}
                      variant='outlined'
                      onClick={() => {
                        setOpenFeedbackModal({
                          open: true,
                          isSendFeedback: true,
                          applicationId: item.applicationId,
                          getApplication: getApplication,
                          setIsFeedbackSent: value => {
                            setFeedbackSentStatus(prev => ({
                              ...prev,
                              [item.applicationId]: value
                            }))
                          },
                          onClose: () => {
                            setOpenFeedbackModal({ open: false })
                          }
                        })
                      }}
                      disabled={feedbackSentStatus[item.applicationId]}
                      name={'Send Feedback'}
                      style={{
                        width: 'fit-content',
                        fontSize: '16px',
                        padding: '12px 27px',
                        borderRadius: '8px',
                        marginTop: '24px'
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid item md={6} xs={12}>
              <Grid item xs={12}>
                {getListData(item)}
                <Grid
                  item
                  xs={12}
                  style={{ display: 'flex', justifyContent: 'right' }}
                >
                  {data?.status != '' && (
                    <AppButton
                      onClick={() => {
                        setOpenModal({
                          open: true,
                          item: item,
                          status: data.status,
                          subStatus: item.subStatus,
                          updateApplication: getApplication,
                          isEdit: false,
                          onClose: () => {
                            setOpenModal({
                              open: false
                            })
                          }
                        })
                      }}
                      name={'Change Status'}
                      style={{
                        width: 'fit-content',
                        fontSize: '16px',
                        padding: '12px 27px',
                        borderRadius: '8px',
                        marginTop: '24px'
                      }}
                    />
                  )}
                </Grid>
                {item.status === 'hired' && (
                  <Grid
                    item
                    xs={12}
                    style={{ display: 'flex', justifyContent: 'right' }}
                  >
                    {item.isJoined &&
                    item.leftOutDate === null &&
                    moment().isBefore(moment(item.guaranteePeriodEndDate)) ? (
                      <AppButton
                        loading={loadingBtn}
                        onClick={() => {
                          setModal({
                            open: true,
                            title: 'Confirm left out',
                            message: `Are you sure that ${item.candidateFirstName} ${item.candidateLastName} has left the job before the ${item.guaranteePeriod}-day guarantee period?`,
                            onClose: () => {
                              setModal({ open: false })
                            },
                            positiveBtnText: 'YES',
                            onClickPositiveButton: () => {
                              setModal({ open: false })
                              setLeftOutDateModal({ open: true, item })
                            },
                            negativeBtnText: 'NO',
                            onClickNegativeButton: () => {
                              setModal({ open: false })
                            }
                          })
                        }}
                        name={'Left out'}
                        style={{
                          width: 'fit-content',
                          fontSize: '16px',
                          padding: '12px 27px',
                          borderRadius: '8px',
                          marginTop: '24px'
                        }}
                      />
                    ) : (
                      item.isJoined === null && (
                        <AppButton
                          loading={loadingBtn}
                          disabled={
                            !moment(item.joiningDate).isSameOrBefore(moment())
                          }
                          onClick={() => {
                            setModal({
                              open: true,
                              title: 'Confirm joining',
                              message: `Could you please confirm whether ${item.candidateFirstName} ${item.candidateLastName} has joined your company?`,
                              positiveBtnText: 'Yes, joined',
                              onClose: () => {
                                setModal({ open: false })
                              },
                              onClickPositiveButton: () => {
                                setModal({ open: false })
                                updateHiredApplicationStatus({
                                  applicationId: item.applicationId,
                                  isJoined: true
                                })
                              },
                              negativeBtnText: 'Not joined',
                              onClickNegativeButton: () => {
                                setModal({ open: false })
                                updateHiredApplicationStatus({
                                  applicationId: item.applicationId,
                                  isJoined: false
                                })
                              }
                            })
                          }}
                          name={'Is Joined?'}
                          style={{
                            width: 'fit-content',
                            fontSize: '16px',
                            padding: '12px 27px',
                            borderRadius: '8px',
                            marginTop: '24px'
                          }}
                        />
                      )
                    )}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        ))
      ) : (
        <NoRecordFound />
      )}
      {openModal?.open && <ChangeStatusModal data={openModal} />}
      {openFeedbackModalodal?.open && (
        <FeedbackModal data={openFeedbackModalodal} />
      )}
      <CustomModal data={modal} />

      {/* Left out date dialog */}
      <Dialog
        open={leftOutDateModal.open}
        PaperProps={{
          component: 'form',
          onSubmit: event => {
            event.preventDefault()
            const formData = new FormData(event.currentTarget)
            const formJson = Object.fromEntries(formData.entries())
            const { leftOutDate } = formJson

            if (isEmpty(leftOutDate)) {
              showToast(
                'Please select the date on which candidate has left your company.'
              )
            } else {
              setLeftOutDateModal({ open: false, item: null })
              updateHiredApplicationStatus({
                applicationId: leftOutDateModal.item.applicationId,
                leftOutDate: dayjs(leftOutDate).format('YYYY-MM-DD 00:00:00')
              })
            }
          }
        }}
      >
        <DialogTitle>Confirm Left out date</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please select the date on which candidate has left your company.
          </DialogContentText>
          <DatePicker
            name='leftOutDate'
            minDate={dayjs(leftOutDateModal?.item?.joiningDate)}
            maxDate={dayjs()}
            sx={{
              mt: 2
            }}
            label='Left out date'
            InputProps={{
              classes: {}
            }}
            renderInput={params => (
              <TextField sx={{ width: '100%' }} {...params} />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setLeftOutDateModal({ open: false, item: null })
            }}
          >
            Cancel
          </Button>
          <Button type='submit'>Submit</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  )
}

function ChangeStatusModal ({ data }) {
  var theme = useTheme()
  var { open, item, status, updateApplication, isEdit, onClose } = data

  const [confirmationOpen, setConfirmationOpen] = useState({ open: false })

  const [jobStatus, setJobStatus] = useState('underConsideration')

  const [subStatus, setSubStatus] = useState('')
  const [baseSalary, setBaseSalary] = useState('')
  const [joiningDate, setJoiningData] = useState(null)

  const [formError, setFormError] = useState({})

  useEffect(() => {
    if (isEdit) {
      setJobStatus(item.status)
      setJoiningData(dayjs(item.joiningDate))
      setBaseSalary(item.baseSalary)
    }
  }, [isEdit])

  const validateForm = () => {
    const error = {}

    if (isEmpty(jobStatus)) {
      error.jobStatus = 'Please select job status.'
    }
    if (data.status === 'underConsideration') {
      if (jobStatus === 'underConsideration') {
        if (isEmpty(subStatus)) {
          error.subStatus = 'Please select sub status.'
        }
      }
    }

    if (jobStatus === 'hired') {
      if (isEmpty(joiningDate)) {
        error.joiningDate = 'Please select joining date.'
      }
      if (isEmpty(baseSalary)) {
        error.baseSalary = 'Please enter base salary.'
      }
    }
    setFormError(error)
    return Object.keys(error).length === 0
  }

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby='parent-modal-title'
        aria-describedby='parent-modal-description'
      >
        <Box sx={{ ...style, width: 400, borderRadius: '8px' }}>
          <TextMedium>Change job status</TextMedium>

          <p id='parent-modal-description'>
            <Grid container spacing={1}>
              {(status === 'underConsideration' || isEdit) && (
                <>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      margin='normal'
                      error={formError.jobStatus}
                    >
                      <InputLabel id='jobStatus'>Job status *</InputLabel>
                      <Select
                        required
                        labelId='jobStatus-label'
                        id='jobStatus'
                        value={jobStatus}
                        defaultValue='underConsideration'
                        disabled={isEdit ? true : false}
                        label='Job status *'
                        onChange={event => setJobStatus(event.target.value)}
                      >
                        <MenuItem required value={'underConsideration'}>
                          Under consideration
                        </MenuItem>

                        <MenuItem required value={'rejected'}>
                          Reject
                        </MenuItem>
                        <MenuItem required value={'hired'}>
                          Hire
                        </MenuItem>
                      </Select>
                      <FormHelperText>{formError.jobStatus}</FormHelperText>
                    </FormControl>
                  </Grid>

                  {jobStatus === 'underConsideration' && (
                    <Grid item xs={12}>
                      <FormControl
                        fullWidth
                        margin='normal'
                        error={formError.jobStatus}
                      >
                        <InputLabel id='subStatus'>Sub status *</InputLabel>
                        <Select
                          required
                          labelId='subStatus-label'
                          id='subStatus'
                          value={subStatus}
                          label='Sub status *'
                          onChange={event => setSubStatus(event.target.value)}
                        >
                          {data.subStatus === 'managerReview' && (
                            <MenuItem required value={'interviewStage'}>
                              Interview stage
                            </MenuItem>
                          )}

                          {data.subStatus === 'interviewStage' && (
                            <MenuItem required value={'offerStage'}>
                              Offer stage
                            </MenuItem>
                          )}
                        </Select>
                        <FormHelperText>{formError.subStatus}</FormHelperText>
                      </FormControl>
                    </Grid>
                  )}
                  {jobStatus === 'hired' && (
                    <>
                      <Grid item xs={12}>
                        <FormControl
                          fullWidth
                          margin='normal'
                          error={formError.joiningDate}
                        >
                          <DatePicker
                            value={joiningDate}
                            onChange={date => {
                              if (date) {
                                setJoiningData(dayjs(date))
                              }
                            }}
                            minDate={dayjs().add(1, 'day')}
                            label='Joining date'
                            renderInput={params => (
                              <TextField
                                sx={{ width: '100%' }}
                                error={formError?.joiningDate}
                                helperText={formError?.joiningDate}
                                {...params}
                              />
                            )}
                            slotProps={{
                              popper: {
                                sx: {
                                  '.MuiDateCalendar-root': {
                                    overflowY: 'auto',
                                    maxHeight: '50vh'
                                  }
                                }
                              }
                            }}
                          />

                          <FormHelperText>
                            {formError.joiningDate}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl
                          fullWidth
                          margin='normal'
                          error={formError.baseSalary}
                        >
                          <TextField
                            label='Base salary'
                            placeholder='in LPA'
                            disabled={isEdit ? true : false}
                            required
                            fullWidth
                            value={baseSalary}
                            error={formError.baseSalary}
                            helperText={formError.baseSalary}
                            onChange={e => {
                              const input = e.target.value.replace(/\D/g, '')
                              if (input.length < 12) {
                                setBaseSalary(input)
                              }
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </>
                  )}
                </>
              )}
              {status === 'pendingAtEmployer' && (
                <FormControl
                  fullWidth
                  margin='normal'
                  error={formError.jobStatus}
                >
                  <InputLabel id='jobStatus'>Job status *</InputLabel>
                  <Select
                    required
                    labelId='jobStatus-label'
                    id='jobStatus'
                    value={jobStatus}
                    label='Job status *'
                    onChange={event => setJobStatus(event.target.value)}
                  >
                    <MenuItem required value={'underConsideration'}>
                      Under consideration
                    </MenuItem>
                    <MenuItem required value={'rejected'}>
                      Reject
                    </MenuItem>
                  </Select>
                  <FormHelperText>{formError.jobStatus}</FormHelperText>
                </FormControl>
              )}
            </Grid>
          </p>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <AppButton
                name={isEdit ? 'Update' : 'Change status'}
                onClick={() => {
                  if (validateForm()) {
                    setConfirmationOpen({
                      open: true,
                      item: item.applicationId,
                      jobStatus: jobStatus,
                      subStatus: subStatus,
                      baseSalary: baseSalary,
                      joiningDate: joiningDate,
                      updateApplication: updateApplication,
                      onDDClose: onClose,
                      isEdit: isEdit ? true : false,
                      onClose: () => {
                        setConfirmationOpen({
                          open: false
                        })
                      }
                    })
                  }
                }}
              />

              {/* <AppButton
                  name={'Change status'}
                  onClick={() => {
                    if (validateForm()) {
                      setConfirmationOpen({
                        open: true,
                        item: item.applicationId,
                        jobStatus: jobStatus,
                        subStatus: subStatus,
                        baseSalary: baseSalary,
                        joiningDate: joiningDate,
                        updateApplication: updateApplication,
                        onDDClose: onClose,
                        isEdit: false,
                        onClose: () => {
                          setConfirmationOpen({
                            open: false
                          })
                        }
                      })
                    }
                  }}
                /> */}
            </Grid>
            <Grid item xs={6}>
              <AppButton
                variant='outlined'
                name={'Cancel'}
                onClick={() => {
                  onClose()
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {confirmationOpen?.open && <ConfirmationModal data={confirmationOpen} />}
    </>
  )
}

function ConfirmationModal ({ data }) {
  var {
    open,
    item,
    jobStatus,
    subStatus,
    baseSalary,
    joiningDate,
    updateApplication,
    onDDClose,
    isEdit,
    onClose
  } = data
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleYes = () => {
    setLoading(true)
    var body = {
      applicationId: item
    }
    if (!isEdit) {
      body = Object.assign(body, { status: jobStatus })
      if (jobStatus === 'underConsideration') {
        body = Object.assign(body, { subStatus: subStatus })
      }

      if (jobStatus === 'hired') {
        body = Object.assign(body, {
          joiningDate: dayjs(joiningDate).format('YYYY-MM-DD hh:mm:ss'),
          baseSalary: baseSalary
        })
      }
    } else {
      body = Object.assign(body, {
        joiningDate: dayjs(joiningDate).format('YYYY-MM-DD hh:mm:ss')
      })
    }
    ;(isEdit
      ? serverData.changeJoiningDate
      : serverData.changeApplicationStatus)(
      body,
      result => {
        if (result.status) {
          showToast(result.message, false)
          onClose()
          onDDClose()
          updateApplication()
        } else {
          showToast(result.message)
          onClose()
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby='child-modal-title'
        aria-describedby='child-modal-description'
      >
        <Box sx={{ ...style, width: 300, borderRadius: '8px' }}>
          <div style={{ marginBottom: '16px' }}>
            <TextMedium>
              {isEdit
                ? 'Do you really want to change joining date?'
                : 'Do you really want to change the status for this application?'}
            </TextMedium>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <AppButton name={'Yes'} onClick={handleYes} loading={loading} />
            </Grid>
            <Grid item xs={6}>
              <AppButton variant='outlined' name={'No'} onClick={onClose} />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </React.Fragment>
  )
}
